import { SalesItemContainer, SalesItemWrapper } from '@components/BookingFlow/Mobile/salesItems/SalesItemWrapper';
import { ServiceCategoryHeader } from '@components/BookingFlow/Mobile/salesItems/ServiceCategoryHeader';
import { SalesItemBookingCategoryType } from '@navio/nsdk';
import { SALES_ITEM_BOOKING_FLOW_TYPE, ServiceItemsMappedForFleetWithCars } from 'noddi-types';
import { cn } from 'noddi-ui-common';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'noddi-ui-web';
import { useState } from 'react';
import { getPriceFormatted } from '../../../../utils/translation';
import { SalesItemMultipleCars } from './SalesItemMultipleCars';

type ServiceCategoryCollapseCardProps = {
  numberOfSelectedSalesItems: number;
  salesItems: ServiceItemsMappedForFleetWithCars[];
  bookingCategoryType: SalesItemBookingCategoryType;
  salesItemType: SALES_ITEM_BOOKING_FLOW_TYPE;
  mountAsExpanded?: boolean;
};

export const ServiceCategoryFleetCollapseCard = ({
  numberOfSelectedSalesItems,
  salesItemType,
  bookingCategoryType,
  salesItems,
  mountAsExpanded
}: ServiceCategoryCollapseCardProps) => {
  const [isExpanded, setIsExpanded] = useState(!!mountAsExpanded);

  const priceFormDescription = getPriceFormatted(salesItems);

  return (
    <Accordion
      value={isExpanded ? [bookingCategoryType] : []}
      onValueChange={(value) => setIsExpanded(value.includes(bookingCategoryType))}
      className='rounded-xl border bg-card transition-shadow hover:shadow-md'
    >
      <AccordionItem value={bookingCategoryType}>
        <AccordionTrigger headingLevel={2} hideChevron className={cn('p-0 font-normal hover:no-underline')}>
          <ServiceCategoryHeader
            numberOfSelectedSalesItems={numberOfSelectedSalesItems}
            priceFrom={priceFormDescription}
            bookingCategoryType={bookingCategoryType}
            isExpanded={isExpanded}
            isFleet
          />
        </AccordionTrigger>
        <AccordionContent className='p-0'>
          <SalesItemContainer>
            {salesItems.map((item) => (
              <SalesItemWrapper key={item.name}>
                <SalesItemMultipleCars isWrappedInCollapsibleCard type={salesItemType} salesItem={item} />
              </SalesItemWrapper>
            ))}
          </SalesItemContainer>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
